import React from "react";
function SectionTitle(props) {
  return (
    <span className="navigation-section-title purple-text bold my-3" {...props}>
      {props.title}
    </span>
  );
}

export default SectionTitle;
